import { AvailableLanguagesEnum } from 'app/constants/available-languages.enum';

export interface User {
  id: number;
  fullName: string;
  phone: string;
  email: string;
  address: string;
  country: string;
  language: AvailableLanguagesEnum;
  isActive: boolean;
  allowedPPF: number;
  allowedWindows: number;
}

export interface Address {
  address: string;
  country: string;
}
export type UserInfo = Partial<Pick<User, 'address' | 'country' | 'phone' | 'language' | 'id'>>;

export interface Credentials {
  payload: {
    role: 'USER';
    id: number;
  };
  token: string;
  refreshToken: string;
}

export interface UserConfiguration {
  printer?: string;
  plotter?: string;
  filmWidth?: number;
}

export interface LoginData {
  email: string;
  password: string;
  rememberMe: boolean;
}

export const defaultUserConfiguration: UserConfiguration = {
  printer: null,
  plotter: 'PN',
  filmWidth: 150,
};

export interface UserPasswordChange {
  currentPassword: string;
  newPassword: string;
}

export interface Banner {
  id: number;
  picture: string;
}

export type SessionBanner = Pick<Banner, 'picture'>;
